import { Pipe, PipeTransform } from '@angular/core';
import { Time } from '../../shared';
/*
 * Usage:
 *   obj: Date | datePretty
*/
@Pipe({name: 'UStime'})
export class USTimePipe implements PipeTransform {
  transform(time: Time): string {
    return new Time(time.hour, time.minute).toEastern();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/us-time.pipe.ts